import { render, staticRenderFns } from "./comment-see.vue?vue&type=template&id=94bca25e&scoped=true&"
import script from "./comment-see.vue?vue&type=script&lang=js&"
export * from "./comment-see.vue?vue&type=script&lang=js&"
import style0 from "./comment-see.vue?vue&type=style&index=0&id=94bca25e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bca25e",
  null
  
)

export default component.exports